// -----------------------------------------------------------------------------
// Wake Lock (Fase 6) — mantiene lo schermo attivo durante la partita.
// Best-effort: nessun errore se l'API non è disponibile (es. alcuni Safari).
// Non tocca la logica del timer 10s.
// -----------------------------------------------------------------------------
let sentinel = null;

export async function requestWakeLock() {
  try {
    if (typeof navigator !== "undefined" && "wakeLock" in navigator) {
      sentinel = await navigator.wakeLock.request("screen");
      if (sentinel && typeof sentinel.addEventListener === "function") {
        sentinel.addEventListener("release", () => {
          sentinel = null;
        });
      }
      return true;
    }
  } catch {
    sentinel = null; // rifiutato/non disponibile: si prosegue senza
  }
  return false;
}

export async function releaseWakeLock() {
  try {
    if (sentinel) {
      await sentinel.release();
    }
  } catch {
    // no-op
  } finally {
    sentinel = null;
  }
}

export function hasWakeLock() {
  return !!sentinel;
}
